import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NavigationModule} from "../navigation/navigation.module";
import {AuthModule} from "../shared/auth/auth.module";
import {StoreManagementModule} from "../store-management/store-management.module";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {VisbosClientComponent} from "./visbos-client.component";
import {CRMModule} from "../crm/crm.module";
import {visbosClientRouting, visbosClientRoutingProviders} from "./visbos-client.routes";
import {RouterModule} from "@angular/router";
import {MedicineStickersModule} from "../medicine-stickers/medicine-stickers.module";
import {WelcomeViewComponent} from './welcome-view/welcome-view.component';
import {SensorsModule} from "../sensors/sensors.module";
import {AdminModule} from "../admin/admin.module";

@NgModule({
  imports: [
    CommonModule,
    StoreManagementModule,
    AuthModule,
    NavigationModule,
    VisbosCoreModule,
    visbosClientRouting,
    CRMModule,
    StoreManagementModule,
    MedicineStickersModule,
    SensorsModule,
    AdminModule
  ],
  declarations: [VisbosClientComponent, visbosClientRoutingProviders, WelcomeViewComponent],
  exports: [RouterModule]
})
export class VisbosClientModule {
}



// WEBPACK FOOTER //
// ./src/app/visbos-client/visbos-client.module.ts